import { useAppSelector } from "../store/hooks"
import { selectCartItems } from "../store/slices/cartSlice"
import { selectWishlistItems } from "../store/slices/wishlistSlice"

export const useProductStatus = () => {
  const cartItems = useAppSelector(selectCartItems)
  const wishlistItems = useAppSelector(selectWishlistItems)

  const isInCart = (productId) => {
    if (!productId || !cartItems) return false
    const item = cartItems.find((item) => item.product?.id === productId)
    return item ? true : false
  }

  const getCartQuantity = (productId) => {
    if (!productId || !cartItems) return 0
    const item = cartItems.find((item) => item.product?.id === productId)
    return item ? item.quantity : 0
  }

  const getProductInStock = (productId) => {
    if (!productId || !cartItems) return 0
    const item = cartItems.find((item) => item.product?.id === productId)?.product?.stock
    return item ? item : 0;
  }

  const getProductInStockFromSKUs = (allData, productId) => {
    if (!productId || !allData) return 0
    const item = allData.find((item) => item?.id === productId)?.stock
    return item ? item : 0;
  }

  const isInWishlist = (productId) => {
    if (!productId || !wishlistItems) return false
    return wishlistItems.some((item) => item.id === productId)
  }

  const isStockLimitAvailable = (stock, quantity) => {
    if (stock === undefined || stock === null) return false
    return stock >= quantity
  }

  return {
    isInCart,
    getCartQuantity,
    getProductInStock,
    getProductInStockFromSKUs,
    isInWishlist,
    isStockLimitAvailable,
  }
}
